<template>

  <div>
    <!-- <h3 class='text-left'> Lista de Produtos </h3>
        <hr /> -->

    <div class="row mt-5 mb-5" v-if="listaProdutos.length == 0">
      <div class="col">

        <div class="alert alert-info">
          <b>Nosso estoque esta vazio no momento! </b>
          <br />
          Em breve novos produtos estarão disponível!
        </div>
      </div>

    </div>


    <div class="row mt-4 ">
      <div class="col-12 text-left">

        <h6><b>Verifique se sua região está em um dos locais de entregas disponíveis:</b></h6>

        <select class="form-control form-control-lg" v-model="local" placeholder="local de entrega"
        style="background:#efa12c">

          <option value=""> -- Escolha uma das regiões -- </option>

          <option v-for="local in locaisEntregas" :key="local.id" :value="local.id">
            {{local.nome}} {{local.valorMinimo > 0 ? ` - min. R$ `+local.valorMinimo : ''}}
          </option>
        </select>

      <div v-if='obsRegiao' class="alert alert-info" style='margin-top:1em'>
           <b> {{ obsRegiao }} </b>
      </div>

      </div>

    </div>

    <div class="row mt-4 listaprodutos" :class="{disable:(local==0)}">
      <div class="col-12 text-left">
        <h6>
            <b>Produtos disponíveis:</b>
        </h6>
        <selecionar-produto v-for="produto in listaProdutos" :key="'produto'+produto.id" :produto="produto"
          v-model="local" />

      </div>

    </div>


    <hr />
    <div class="row">

      <div class="col-12">

        <h5 v-if="minhacesta.length>0"> Total em produtos: <b> R$ {{ total  }}</b> </h5>
        <h5 v-if="minhacesta.length>0"> Total da taxa de entrega: <b> R$ {{  15 }}</b> </h5>
        <h3 v-if="minhacesta.length>0" class='mt-2'> Total: <b> R$ {{ total+  15 }}</b> </h3>

      </div>
    </div>

      <div class="row" v-if="listaProdutos.length > 0">
         <div class="col"> 
          
          <div class="" v-if="( minhacesta.length>0 && ( valorMinimoRegiao === 0 || ( total+ 15 ) >= valorMinimoRegiao))">
            <router-link  to="/confirmarpedido" class='btn btn-grande'> FAZER PEDIDO
            </router-link>
          </div>
          <div v-else>
            <div v-if="(minhacesta.length>0  && valorMinimoRegiao > 0 && ( total+ 15 ) < valorMinimoRegiao)" class="alert alert-danger">
                O valor mínimo para entregas na região <br /><b>{{nomeRegiao}}</b> é de <b>R$ {{valorMinimoRegiao}}</b>
              <router-link  to="/" class='btn btn-grande disabled'> FAZER PEDIDO </router-link>
            </div>
             <router-link v-else to="/" class='btn btn-grande disabled'> FAZER PEDIDO </router-link>
          </div>
          

          


      </div>
    </div>

  </div>

</template>



<script>
import SelecionarProduto from './selecionar-produto.vue'
export default {
    components:{
        SelecionarProduto
    },

    computed:{
        local:{
            set:function(val){
                this.$store.commit('localCliente',val)
            },
            get:function(){
                return this.$store.state.localCliente
            }
        },
        listaProdutos:function(){
            return this.$store.getters.lista
        },
        minhacesta:function(){
            return this.$store.getters.minhacesta
        },
        total:function(){
            return this.$store.getters.total
        },
        locaisEntregas:function(){
            return this.$store.getters.locaisEntregas
        },
        valorMinimoRegiao: function(){
          let locais = this.locaisEntregas
          let local = locais.find(l=>l.id === this.local)
          return local.valorMinimo
        },
        nomeRegiao: function(){
          let locais = this.locaisEntregas
          let local = locais.find(l=>l.id === this.local)
          return local.nome
        },
        obsRegiao: function(){
          let locais = this.locaisEntregas
          let local = locais.find(l=>l.id === this.local)
          return local?.obs ?? ''
        }
    }

}

</script>

<style>
    .listaprodutos.disable{
        opacity:0.2;
        pointer-events:none;
    }
</style>